const ftpHost = 'ftp.datasmarty.net';
const productionUrl = 'https://api.datasmarty.net';
const developmentUrl = 'https://demo.datasmarty.net';
const baseUrl = process.env.NODE_ENV === 'production' ? productionUrl : developmentUrl;

export default {
  baseUrl, ftpHost,
};
